module.exports = __webpack_public_path__ + "img/logo2x.20347c9d.png";